export function isTurboFrame(element) {
    return element.nodeName == "TURBO-FRAME";
}
